import { css } from "@web/helpers/webComponents";
import { GameObjectReference } from "@shared/types";

const styles: string = css`
    
    :host {
        position: absolute;
        top: -4.5rem;
        right: 1.65rem;
        
        z-index: 15;
    }

    /* Inventory */
    .inventory {
        display: flex;
        gap: 1rem;
        align-items: center;

        margin-left: 1.15rem;
        margin-top: -2rem;
    }

    .inventory-items {
        padding-inline-start: 0;
        list-style: none;
        display: flex;
        gap: 0.5rem;

        font-size: 2.2rem;
        text-align: center;
    }

    .inventory-item {
        width: 3rem;
        height: 3rem;
        background: var(--color-white);

        padding-bottom: 0.2rem;
    }


`;

/**
 * Inventory with collected items
 *
 * @author Kyrylo Maliuha
 */
export class InventoryComponent extends HTMLElement {
    /** Inventory */
    private _inventory: GameObjectReference[] = [];

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    public set inventory(items: GameObjectReference[]) {
        this._inventory = items;
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
                <section class="inventory" aria-labelledby="inventoryTitle">
                    <ul class="inventory-items">
                        ${this._inventory.map(object => `<li class="inventory-item" title="${object.alias}">
                            ${object.emoji}
                        </li>`).join("")}
                    </ul>
                </section>
        `;
    }
}

customElements.define("inventory-bar", InventoryComponent);
